import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const DeleteConfirmDialog = ({
  open,
  onClose,
  fileToDelete,
  onConfirm
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">파일 삭제</DialogTitle>
      <DialogContent>
        <Typography id="delete-dialog-description">
          "{fileToDelete?.standard_file_name || fileToDelete?.file_name}" 파일을 삭제하시겠습니까?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button onClick={onConfirm} color="error" autoFocus>삭제</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
